export const ModeReglementDTO = {
  Virement: 'Virement',
  Cheque: 'Cheque',
  Prelevement: 'Prelevement',
  CB: 'CB',
  Autre: 'Autre',
  CompensationCreances: 'CompensationCreances'
}

export type ModeReglementDTO = keyof typeof ModeReglementDTO

export const ModeReglementLibelle: { [key in ModeReglementDTO]: string } = {
  Virement: 'Virement',
  Cheque: 'Chèque',
  Prelevement: 'Prélèvement',
  CB: 'Carte bancaire',
  Autre: 'Autres',
  CompensationCreances: 'Compensation de créances'
}
